export default __webpack_public_path__ + "static/media/groomlog.cb3ffab7.png";